import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { RichTextEditor } from '../rich-text-editor/RichTextEditor'
import { Form, Input, Select, Button, Upload, Icon, Switch, Tooltip } from 'antd'
import BunkeyApi from '../../api/BunkeyAPI'
import { withRouter } from 'react-router'
import axios from 'axios'
import { getAssetType, ENDPOINT } from '../../utils'
import { sendNotification } from '../../utils/index'
import './create.css'

const Option = Select.Option

const { TextArea } = Input

export class Create extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isFetching: false,
      title: null,
      category: null,
      description: null,
      content: null,
      fixed: false,
      previewImage: null,
      viewImage: null,
      circleClass: '',
      errors: []
    }
  }

  handleOnInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleOnSelectChange = (value) => {
    let cclass = ''
    switch (value) {
      case 'dam':
        cclass = 'post-yellow'
        break;
      case 'marketing':
        cclass = 'post-green'
        break;
      case 'bunkey':
        cclass = 'post-purple'
        break;
      default:
        break;
    }
    this.setState({
      category: value,
      circleClass: cclass
    })
  }

  handleContent = (value) => {
    this.setState({
      content: value
    })
  }

  handleValidator = () => {
    let errors = []
    const { title, category, description, content, previewImage, viewImage } = this.state
    if (!title) {
      errors.push('title')
    }
    if (!category) {
      errors.push('category')
    }
    if (!previewImage) {
      errors.push('previewImage')
    }
    if (!viewImage) {
      errors.push('viewImage')
    }
    if (!description) {
      errors.push('description')
    }
    if (!content) {
      errors.push('content')
    }

    if (errors.length > 0) {
      this.setState({
        errors
      })
      return false
    } else {
      return true
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (!this.handleValidator()) return

    let promises = []
    const { title, category, fixed, description, content, previewImage, viewImage } = this.state

    this.setState({
      isFetching: true
    })

    promises.push(new Promise((resolve, reject) => {
      const client = axios.create({
        baseURL: ENDPOINT
      })
      client.put(previewImage.metadata.url,
        previewImage.file,
        {
          headers: {
            'Content-Type': previewImage.file.type,
            'Content-Disposition': 'attachment'
          }
        })
        .then(function (resp) {
          resolve(resp)
        })
        .catch(function (err) {
          reject(err)
        })
    }))

    promises.push(new Promise((resolve, reject) => {
      const client = axios.create({
        baseURL: ENDPOINT
      })
      client.put(viewImage.metadata.url,
        viewImage.file,
        {
          headers: {
            'Content-Type': viewImage.file.type,
            'Content-Disposition': 'attachment'
          }
        })
        .then(function (resp) {
          resolve(resp)
        })
        .catch(function (err) {
          reject(err)
        })
    }))

    promises.push(new Promise((resolve, reject) => {
      const { user } = this.props
      BunkeyApi({
        url: `/cms/manager/posts`,
        method: 'POST',
        data: {
          title,
          content,
          description,
          previewImage: previewImage.metadata.futureFileURL,
          viewImage: viewImage.metadata.futureFileURL,
          author: user.email,
          category,
          fixed
        }
      }).then(resp => {
        resolve(resp)
      }).catch(err => {
        reject(err)
      })
    }))

    Promise.all(promises).then(resp => {
      this.props.history.push('/manager/cms?status=success')
    }, reason => {
      const { intl } = this.props
      sendNotification('error', intl, intl.formatMessage({ id: 'post_not_created' }))
    })
  }

  handleUrlSignaturePreview = value => {
    BunkeyApi({
      url: `/cms/manager/url-signature`,
      method: 'POST',
      data: {
        'clientId': 'assets',
        'mimeType': value.type,
        'extention': getAssetType(value.type)
      }
    }).then(resp => {
      if (resp.data) {
        this.setState({
          previewImage: {
            file: value,
            metadata: resp.data
          }
        })
      }
    }).catch(err => {
      this.setState({
        previewImage: null
      })
    })
    return false
  }

  handleOnRemovePreview = () => {
    this.setState({
      previewImage: null
    })
  }

  handleUrlSignatureView = value => {
    BunkeyApi({
      url: `/cms/manager/url-signature`,
      method: 'POST',
      data: {
        'clientId': 'assets',
        'mimeType': value.type,
        'extention': getAssetType(value.type)
      }
    }).then(resp => {
      if (resp.data) {
        this.setState({
          viewImage: {
            file: value,
            metadata: resp.data
          }
        })
      }
    }).catch(err => {
      this.setState({
        viewImage: null
      })
    })
    return false
  }

  handleOnRemoveView = () => {
    this.setState({
      viewImage: null
    })
  }

  handleOnChangeFixed = (checked) => {
    this.setState({
      fixed: checked
    })
  }

  handleBack = () => {
    this.props.history.push('/manager')
  }

  render() {
    const { isFetching, title, description, circleClass, errors } = this.state

    return (
      <React.Fragment>
      <div className="title-bar">
        <div className="container">
          <span>Crear nuevo post</span>
          <div style={{
            display: 'block',
            float: 'right',
            marginRight: 15,
            marginTop: 10
          }}>
            <button onClick={this.handleBack} className="ant-btn ant-btn-primary">Volver</button>
          </div>
        </div>
      </div>
        <div className="assets-wrapper">
          <div className="container">
            <Form layout="vertical" onSubmit={this.handleSubmit}>
              <Form.Item>
                <FormattedMessage id="post_title" />
                <Input name='title' value={title} onChange={this.handleOnInputChange} />
                {errors.find(r => r === 'title') && <span className="post-error">Campo obligatorio</span>}
              </Form.Item>
              <Form.Item>
                <FormattedMessage id="post_category" /><div className={`post-circle ${circleClass}`}></div>
                <Select defaultValue="seleccione" onChange={this.handleOnSelectChange} >
                  <Option value={null}>Seleccionar</Option>
                  <Option value="dam">DAM´s</Option>
                  <Option value="marketing">Marketing</Option>
                  <Option value="bunkey">Bunkey</Option>
                </Select>
                {errors.find(r => r === 'category') && <span className="post-error">Campo obligatorio</span>}
              </Form.Item>
              <Form.Item>
                <div>
                  ¿Fijar post?
                    <Tooltip placement="right" title="Si el post se establece fijo aparecerá siempre al comienzo"><Icon type="question-circle" style={{ margin: 10 }} /></Tooltip>
                </div>
                <Switch onChange={this.handleOnChangeFixed} />
              </Form.Item>
              <Form.Item>
                <div style={{ display: 'flex' }}>
                  <Upload
                    beforeUpload={this.handleUrlSignaturePreview}
                    onRemove={this.handleOnRemovePreview}
                    listType='picture'>
                    <Button>
                      <Icon type="upload" /> <FormattedMessage id="post_preview_image" />
                    </Button>
                  </Upload>
                  <Tooltip placement="right" title="Esta es la imagen que se previsualiza en la página principal"><Icon type="question-circle" style={{ margin: 10 }} /></Tooltip>
                </div>
                {errors.find(r => r === 'previewImage') && <span className="post-error">Campo obligatorio</span>}
              </Form.Item>
              <Form.Item>
                <div style={{ display: 'flex' }} >
                  <Upload
                    beforeUpload={this.handleUrlSignatureView}
                    onRemove={this.handleOnRemoveView}
                    listType='picture'>
                    <Button>
                      <Icon type="upload" /> <FormattedMessage id="post_view_image" />
                    </Button>
                  </Upload>
                  <Tooltip placement="right" title="Esta es la imagen que se previsualiza al ver el detalle del post"><Icon type="question-circle" style={{ margin: 10 }} /></Tooltip>
                </div>
                {errors.find(r => r === 'viewImage') && <span className="post-error">Campo obligatorio</span>}
              </Form.Item>
              <Form.Item>
                <FormattedMessage id="post_description" /> (Texto que aparece en el listado de contenido)
                  <TextArea name='description' value={description} onChange={this.handleOnInputChange} rows={4} />
                {errors.find(r => r === 'description') && <span className="post-error">Campo obligatorio</span>}
              </Form.Item>
              <Form.Item>
                <FormattedMessage id="post_content" /> (Texto que aparece al ver el detalle del contenido)
                  <RichTextEditor onType={this.handleContent} />
                {errors.find(r => r === 'content') && <span className="post-error">Campo obligatorio</span>}
              </Form.Item>
              <Form.Item>
                <Button onClick={this.handleBack}>Volver</Button>
                <Button loading={isFetching} type="primary" htmlType="submit" style={{ marginLeft: 10 }}>Crear</Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Create)))